/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgErp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17.247 11.626c.357-.956-.529-1.645-1.308-1.545-.965.08-2.462.361-3.954.946-1.497.586-3.114 1.527-4.123 3.005l-.01.014-.008.014c-.326.513-.144 1.061.106 1.357.276.327.674.46 1.043.453 1.908-.03 3.726-.519 5.173-1.254 1.406-.716 2.624-1.752 3.081-2.99z"
        fill="currentcolor"
      />
      <path
        d="M21.67 4.007a1.385 1.385 0 0 0-.668.103 2.85 2.85 0 0 0-.385.198c-.068.04-.132.08-.198.12-.162.1-.331.204-.568.331-.63.34-1.68.803-3.505 1.195-4.753 1.023-7.744 1.985-9.943 3.547-2.227 1.583-3.54 3.712-5.117 6.76-.282.545-.485 1.32.032 1.98.415.53 1.081.66 1.451.71 8.61 1.201 13.734-1.076 16.685-4.226 2.896-3.09 3.54-6.855 3.54-8.416l.003-.24v-.015C23 5.978 23 5.895 23 5.815c0-.162-.004-.375-.043-.586a1.542 1.542 0 0 0-.372-.776 1.43 1.43 0 0 0-.91-.445h-.004zM16.768 7.91c2-.43 3.227-.957 4.032-1.39.067-.035.132-.071.194-.106-.03 1.265-.602 4.386-2.998 6.944-2.399 2.56-6.787 4.724-14.832 3.629 1.511-2.904 2.632-4.6 4.399-5.856 1.834-1.303 4.464-2.201 9.205-3.221z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgErp as Erp };
